import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";

export default function PolitiqueCookies() {
  return (
    <Layout>
      <div className="min-h-screen bg-white py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-8">
          <div className="mb-12">
            <Link 
              to={ROUTE_PATHS.HOME}
              className="text-sm text-[#6e6e73] hover:text-[#1d1d1f] transition-colors mb-4 inline-block"
            >
              ← Retour à l'accueil
            </Link>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
              Politique de Cookies
            </h1>
            <p className="text-lg text-[#6e6e73]">
              Conforme au Règlement Général sur la Protection des Données (RGPD — UE 2016/679)
            </p>
            <p className="text-sm text-[#6e6e73] mt-2">
              Mise à jour : 31 mars 2026
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="mb-8 p-6 bg-[#f5f5f7] rounded-lg">
              <p className="text-[#1d1d1f] leading-relaxed">
                La présente politique de cookies décrit la manière dont <strong>Camille Vega (SARL, SIRET : 988 977 260 00013)</strong> utilise des cookies et technologies similaires sur le site internet <strong>camillevega.fr</strong>.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed mt-4">
                Cette politique s'applique conformément au Règlement Général sur la Protection des Données (RGPD — UE 2016/679) et aux recommandations de la CNIL.
              </p>
            </div>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                1. Qu'est-ce qu'un cookie ?
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) lors de la visite d'un site internet. Il permet au site de mémoriser des informations sur votre visite, comme votre langue de préférence et d'autres paramètres, afin de faciliter votre prochaine visite et de rendre le site plus utile.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed">
                Les cookies peuvent être déposés par le site que vous visitez (cookies "first party") ou par des sites tiers (cookies "third party") qui fournissent des services au site visité.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                2. Quels cookies utilisons-nous ?
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-6">
                Le site <strong>camillevega.fr</strong> utilise uniquement des cookies strictement nécessaires à son fonctionnement. Aucun cookie analytique, publicitaire ou de réseaux sociaux n'est déposé sans votre consentement préalable.
              </p>

              <div className="overflow-x-auto mb-6">
                <table className="w-full border-collapse border border-[#d2d2d7]">
                  <thead>
                    <tr className="bg-[#f5f5f7]">
                      <th className="border border-[#d2d2d7] px-4 py-3 text-left text-[#1d1d1f] font-semibold">Type de cookie</th>
                      <th className="border border-[#d2d2d7] px-4 py-3 text-left text-[#1d1d1f] font-semibold">Finalité</th>
                      <th className="border border-[#d2d2d7] px-4 py-3 text-left text-[#1d1d1f] font-semibold">Durée</th>
                      <th className="border border-[#d2d2d7] px-4 py-3 text-left text-[#1d1d1f] font-semibold">Consentement requis</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f] font-semibold">Cookies strictement nécessaires</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Permettent le fonctionnement de base du site (navigation, sécurité, préférences de session)</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Session ou 13 mois max</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Non</td>
                    </tr>
                    <tr className="bg-[#f5f5f7]">
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f] font-semibold">Cookies analytiques</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Permettent de mesurer l'audience et d'améliorer le site</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">13 mois max</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Oui</td>
                    </tr>
                    <tr>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f] font-semibold">Cookies publicitaires</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Permettent d'afficher des publicités ciblées</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">13 mois max</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Oui</td>
                    </tr>
                    <tr className="bg-[#f5f5f7]">
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f] font-semibold">Cookies de réseaux sociaux</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Permettent de partager du contenu sur les réseaux sociaux</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">13 mois max</td>
                      <td className="border border-[#d2d2d7] px-4 py-3 text-[#1d1d1f]">Oui</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="p-6 bg-[#C9793A] bg-opacity-10 border-l-4 border-[#C9793A] rounded">
                <p className="text-[#1d1d1f] font-semibold mb-2">
                  État actuel sur camillevega.fr :
                </p>
                <p className="text-[#1d1d1f]">
                  Seuls les <strong>cookies strictement nécessaires</strong> sont actuellement utilisés. Aucun cookie analytique, publicitaire ou de réseaux sociaux n'est déposé.
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                3. Cookies strictement nécessaires
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés dans nos systèmes. Ils sont généralement établis en réponse à des actions que vous effectuez et qui constituent une demande de services, telles que :
              </p>
              <ul className="list-disc ml-6 space-y-2 text-[#1d1d1f] mb-4">
                <li>La définition de vos préférences en matière de confidentialité</li>
                <li>La connexion à votre espace membre (si applicable)</li>
                <li>Le remplissage de formulaires</li>
                <li>La sécurisation de la navigation</li>
              </ul>
              <p className="text-[#1d1d1f] leading-relaxed">
                Conformément aux recommandations de la CNIL, ces cookies ne nécessitent pas de consentement préalable car ils sont strictement nécessaires à la fourniture du service expressément demandé par l'utilisateur.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                4. Votre consentement
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Conformément au RGPD et aux recommandations de la CNIL, tout cookie non strictement nécessaire au fonctionnement du site nécessite votre consentement préalable, libre, spécifique, éclairé et univoque.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Si nous décidons à l'avenir d'utiliser des cookies analytiques, publicitaires ou de réseaux sociaux, nous vous demanderons votre consentement explicite via une bannière de cookies conforme au RGPD.
              </p>
              <div className="p-6 bg-[#f5f5f7] rounded-lg">
                <h3 className="font-semibold text-[#1d1d1f] mb-3">Vous pourrez alors :</h3>
                <ul className="list-disc ml-6 space-y-2 text-[#1d1d1f]">
                  <li>Accepter tous les cookies</li>
                  <li>Refuser tous les cookies non essentiels</li>
                  <li>Personnaliser vos choix par catégorie de cookies</li>
                  <li>Modifier vos préférences à tout moment</li>
                </ul>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                5. Comment gérer vos cookies ?
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Vous pouvez à tout moment choisir de désactiver les cookies via les paramètres de votre navigateur. Voici comment procéder selon votre navigateur :
              </p>

              <div className="space-y-4">
                <div className="p-4 bg-[#f5f5f7] rounded-lg">
                  <h3 className="font-semibold text-[#1d1d1f] mb-2">Google Chrome</h3>
                  <p className="text-[#1d1d1f] text-sm">
                    Menu → Paramètres → Confidentialité et sécurité → Cookies et autres données de sites
                  </p>
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#C9793A] hover:underline text-sm">
                    En savoir plus →
                  </a>
                </div>

                <div className="p-4 bg-[#f5f5f7] rounded-lg">
                  <h3 className="font-semibold text-[#1d1d1f] mb-2">Mozilla Firefox</h3>
                  <p className="text-[#1d1d1f] text-sm">
                    Menu → Options → Vie privée et sécurité → Cookies et données de sites
                  </p>
                  <a href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies" target="_blank" rel="noopener noreferrer" className="text-[#C9793A] hover:underline text-sm">
                    En savoir plus →
                  </a>
                </div>

                <div className="p-4 bg-[#f5f5f7] rounded-lg">
                  <h3 className="font-semibold text-[#1d1d1f] mb-2">Safari (macOS)</h3>
                  <p className="text-[#1d1d1f] text-sm">
                    Préférences → Confidentialité → Gérer les données de sites web
                  </p>
                  <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#C9793A] hover:underline text-sm">
                    En savoir plus →
                  </a>
                </div>

                <div className="p-4 bg-[#f5f5f7] rounded-lg">
                  <h3 className="font-semibold text-[#1d1d1f] mb-2">Microsoft Edge</h3>
                  <p className="text-[#1d1d1f] text-sm">
                    Menu → Paramètres → Confidentialité, recherche et services → Cookies et autorisations de site
                  </p>
                  <a href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#C9793A] hover:underline text-sm">
                    En savoir plus →
                  </a>
                </div>
              </div>

              <div className="mt-6 p-6 bg-[#C9793A] bg-opacity-10 border-l-4 border-[#C9793A] rounded">
                <p className="text-[#1d1d1f] font-semibold mb-2">
                  ⚠️ Attention :
                </p>
                <p className="text-[#1d1d1f]">
                  La désactivation de certains cookies peut affecter le fonctionnement du site et limiter votre expérience utilisateur.
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                6. Durée de conservation des cookies
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Conformément aux recommandations de la CNIL, la durée de conservation des cookies est limitée :
              </p>
              <ul className="list-disc ml-6 space-y-2 text-[#1d1d1f]">
                <li><strong>Cookies de session :</strong> Supprimés automatiquement à la fermeture du navigateur</li>
                <li><strong>Cookies persistants :</strong> Maximum 13 mois à compter du premier dépôt</li>
                <li><strong>Consentement aux cookies :</strong> Valable 13 mois maximum, puis redemandé</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                7. Cookies tiers
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Actuellement, le site <strong>camillevega.fr</strong> n'utilise pas de cookies tiers (cookies déposés par des sites externes).
              </p>
              <p className="text-[#1d1d1f] leading-relaxed">
                Si nous décidons à l'avenir d'intégrer des services tiers (outils d'analyse, réseaux sociaux, publicité), nous mettrons à jour cette politique et vous demanderons votre consentement préalable.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                8. Vos droits
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Conformément au RGPD, vous disposez des droits suivants concernant vos données personnelles collectées via les cookies :
              </p>
              <ul className="list-disc ml-6 space-y-2 text-[#1d1d1f] mb-4">
                <li><strong>Droit d'accès :</strong> Obtenir une copie des données collectées</li>
                <li><strong>Droit de rectification :</strong> Corriger des données inexactes</li>
                <li><strong>Droit à l'effacement :</strong> Demander la suppression de vos données</li>
                <li><strong>Droit d'opposition :</strong> Vous opposer au traitement de vos données</li>
                <li><strong>Droit de retirer votre consentement :</strong> À tout moment, sans effet rétroactif</li>
              </ul>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Pour exercer vos droits, contactez-nous à : <a href="mailto:camille@camillevega.com" className="text-[#C9793A] hover:underline font-semibold">camille@camillevega.com</a>
              </p>
              <p className="text-[#1d1d1f] leading-relaxed">
                Pour plus d'informations sur vos droits, consultez notre <Link to={ROUTE_PATHS.CONFIDENTIALITE} className="text-[#C9793A] hover:underline font-semibold">Politique de Confidentialité</Link>.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                9. Mises à jour de cette politique
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Nous nous réservons le droit de modifier cette politique de cookies à tout moment, notamment pour nous conformer à de nouvelles obligations légales ou à des évolutions techniques.
              </p>
              <p className="text-[#1d1d1f] leading-relaxed">
                La date de dernière mise à jour figure en haut de ce document. Nous vous encourageons à la consulter régulièrement.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
                10. Contact
              </h2>
              <p className="text-[#1d1d1f] leading-relaxed mb-4">
                Pour toute question concernant notre utilisation des cookies :
              </p>
              <div className="p-6 bg-[#f5f5f7] rounded-lg">
                <p className="text-[#1d1d1f] mb-2"><strong>Email :</strong> <a href="mailto:camille@camillevega.com" className="text-[#C9793A] hover:underline">camille@camillevega.com</a></p>
                <p className="text-[#1d1d1f] mb-2"><strong>Téléphone :</strong> 06 95 77 11 67</p>
                <p className="text-[#1d1d1f]"><strong>Adresse :</strong> Camille Vega — SARL, 60 rue François Premier, 75008 Paris, France</p>
              </div>
            </section>

            <div className="mt-12 p-6 bg-[#f5f5f7] border-l-4 border-[#C9793A] rounded">
              <p className="text-[#1d1d1f] text-center font-semibold">
                Camille Vega — SARL — Shut Up & Close
              </p>
              <p className="text-[#1d1d1f] text-center text-sm mt-2">
                60 rue François Premier, 75008 Paris · SIRET 988 977 260 00013
              </p>
              <p className="text-[#1d1d1f] text-center text-sm">
                <a href="mailto:camille@camillevega.com" className="text-[#C9793A] hover:underline">camille@camillevega.com</a> · <a href="https://camillevega.fr" target="_blank" rel="noopener noreferrer" className="text-[#C9793A] hover:underline">camillevega.fr</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
